
<script>
export default {
	name: 'text-area-resize',
	methods: {
		resizeTextarea(event) {
			event.target.style.height = 'auto';
			event.target.style.height = event.target.scrollHeight + 'px';
		},
	},
	mounted() {
		this.$el.addEventListener('input', this.resizeTextarea);
	},
	updated() {
		if (this.$el.setAttribute) {
			this.$el.setAttribute('style', 'height:' + this.$el.scrollHeight + 'px;overflow-y:hidden;');
		}
	},
	beforeDestroy() {
		this.$el.removeEventListener('input', this.resizeTextarea);
	},
	render() {
		return (this.$slots.default || [])[0];
	},
};
</script>

